<template>
    <div class="section row clearfix topmargin">
        <div class="col-md-12">
            <div v-if="!producerGroupMembership" class="ml-3">
                <b-spinner small></b-spinner>&nbsp;Loading group membership...
            </div>
            <div v-if="producerGroupMembership && producerGroupMembership.length === 0" class="ml-3">
                <h3>{{currentGroup.name}}</h3>
                <p>This group doesn't have any members or they are still pending.</p>

                <b-button :to="{name: 'enroll', params: {groupid: currentGroup.underwritter + currentGroup.group}}" variant="success">New Enrollment</b-button>
            </div>
            <member-list
                    :groupcode="groupcode"
                    :items="producerGroupMembership"
                    :title="currentGroup.name +' Membership'"
                    type="producer"
                    v-if="currentGroup && producerGroupMembership && producerGroupMembership.length > 0"></member-list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import MemberList from '../../../components/Dashboard/MemberList'

    export default {
        name: 'Group',
        components: {MemberList},
        props: ['groupcode'],
        computed: {
            ...mapGetters(['producerGroupMembership', 'currentGroup'])
        },
        methods: {
            ...mapActions(['getProducerGroupMembership', 'getGroupData'])
        },
        mounted () {
            this.getProducerGroupMembership(this.groupcode)
            this.getGroupData(this.groupcode)
        }
    }
</script>

<style scoped>

</style>
